import Vue from 'vue';
import { Getter, State } from 'vuex-simple';
import { ux1Data } from '@/Common/Utils/General/Modules';

import matches from '@/HostApp/services/DesignTokens/tokensMatches';
import VariablesSass from '@/HostApp/styles/variables.module.scss';
import cssBundlerModule from '@/HostApp/services/CSSBundler/CSSBundlerModule';

export class DesignTokensModule {
	constructor() {
		this.tokens = Object.keys(VariablesSass).reduce((acc, key) => {
			const keyInCamelCase = ux1Data.changeCase.camelCase(key);
			acc[keyInCamelCase] = VariablesSass[key];

			return acc;
		}, {} as Common.IMap<string>);
	}

	@State()
	private readonly tokens: Common.IMap<string> = {};

	@State()
	public api: Partial<DesignTokensModule> = {
		setTokenValue: (key: string, value: string) => {
			this.setTokenValue(key, value);
		}
	};

	@Getter()
	public get cssVariables(): Common.IMap<string> {
		return Object.keys(this.tokens).reduce((acc, key) => {
			const value = this.tokens[key];
			const varName = `--${ux1Data.changeCase.paramCase(key)}`;
			acc[varName] = value;
			return acc;
		}, {} as Common.IMap<string>);
	}

	public setTokenValue(key: string, value: string): void {
		Vue.set(this.tokens, key, value);
		const varName = `--${ux1Data.changeCase.paramCase(key)}`;
		cssBundlerModule.setCSSVariableValue(varName, value);
	}

	private getValuesFromStyleSheet(cssStyleSheet: CSSStyleSheet): Common.IMap<string> {
		const matchesKeys = Object.keys(matches);
		const cssRules = Array.from(cssStyleSheet.cssRules) as Array<CSSStyleRule>;

		return cssRules.reduce((acc, rule) => {
			const matchesKeysArray = matchesKeys.filter((key) => {
				const item = matches[key];

				return (
					rule.style &&
					rule.style[item.property as keyof CSSStyleDeclaration] &&
					item.rule === rule.selectorText
				);
			});

			matchesKeysArray.forEach((matchesKey) => {
				acc[matchesKey] = rule.style[matches[matchesKey].property as keyof CSSStyleDeclaration] as string;
			});

			return acc;
		}, {} as Common.IMap<string>);
	}

	public mergeVariablesWithTheme(cssStyleSheet: CSSStyleSheet): void {
		const values = this.getValuesFromStyleSheet(cssStyleSheet);

		Object.keys(values).forEach((key) => {
			this.setTokenValue(key, values[key]);
		});
	}
}

const designTokensModule = new DesignTokensModule();

export default designTokensModule;
